<template>
  <div>
    <div class="pt-3 ">
      <h6
        class="listing-desc-headline margin-top-60"
      >
        Location
      </h6>
      <div id="myMap"></div>
    </div>
  </div>
</template>
<script>
var marker;
const google = window.google;

export default {
  props: ["location"],
  data(){
      return{
          map:null,
      }
  },
  mounted() {
    var mapCanvas = document.getElementById("myMap");
    var mapOptions = {
      // eslint-disable-next-line
      center: new google.maps.LatLng(this.location[1], this.location[0]),
      zoom: 12,
      // eslint-disable-next-line
      mapTypeId: google.maps.MapTypeId.HYBRID,
    };
    var vm = this;
    // eslint-disable-next-line
    vm.map = new google.maps.Map(mapCanvas, mapOptions);
    var latlngset = new google.maps.LatLng(this.location[1], this.location[0]);
    // var iconBase = 'http://maps.google.com/mapfiles/kml/pal4/icon52.png'
    marker = new google.maps.Marker({
      map: vm.map,
      position: latlngset,
    });
    // console.log(msrker);
    var contentString =
      '<table><tr><td colspan=2 style="padding-left:10px;"><p style="font-size:14px;color:#333333;font-weight:500"><b>Name: ' +
      this.name +
      "</b></p></td></tr></table>";
    var infowindow = new google.maps.InfoWindow({
      content: contentString,
    });
    marker.addListener("click", function () {
      infowindow.open(vm.map, marker);
    });
  },
};
</script>
<style>
#myMap {
  height: 300px;
  width: 100%;
}
</style>